document.addEventListener("DOMContentLoaded", function () {
    // ✅ Initialiser GLightbox UNIQUEMENT quand on clique sur "Voir plus"
    document.querySelectorAll(".open-lightbox").forEach(button => {
        button.addEventListener("click", function () {
            let galleryID = this.getAttribute("data-gallery");

            // ✅ Sélectionner uniquement les images de cette galerie
            let galleryImages = document.querySelectorAll(`[data-glightbox="${galleryID}"]`);

            if (galleryImages.length > 0) {
                let lightbox = GLightbox({
                    elements: Array.from(galleryImages).map(img => ({
                        href: img.getAttribute("href"),
                        type: "image",
                        zoomable: true
                    })),
                    touchNavigation: true,
                    loop: true,
                    width: "auto",
                    height: "auto",
                    openEffect: "zoom",
                    closeEffect: "fade"
                });

                lightbox.open();
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    let sidebar = document.querySelector(".sticky-sidebar");
    if (sidebar) {
        let offsetTop = sidebar.offsetTop;
        window.addEventListener("scroll", function () {
            if (window.scrollY > offsetTop) {
                sidebar.classList.add("fixed-sidebar");
            } else {
                sidebar.classList.remove("fixed-sidebar");
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelector(".tabs");
    const selector = document.querySelector(".selector");
    
    if (!tabs || !selector) return; // Sortir si pas de tabs ou de selector

    const tabItems = tabs.querySelectorAll(".nav-link");

    function updateSelector(activeItem) {
        const activeWidth = activeItem.offsetWidth;
        const itemPos = activeItem.offsetLeft;

        selector.style.width = activeWidth + "px";
        selector.style.left = itemPos + "px";
    }

    // Mettre à jour la position initiale
    const activeTab = tabs.querySelector(".nav-link.active");
    if (activeTab) {
        updateSelector(activeTab);
    }

    // Ajouter un écouteur d'événements sur chaque onglet
    tabItems.forEach(tab => {
        tab.addEventListener("click", (e) => {
            e.preventDefault();

            // Supprimer la classe active de tous les onglets
            tabItems.forEach(item => item.classList.remove("active"));

            // Ajouter la classe active à l'onglet sélectionné
            tab.classList.add("active");

            // Mettre à jour la position du sélecteur
            updateSelector(tab);
        });
    });

    const tabContent = document.getElementById('applicationTabsContent');
    if (tabContent) {
        tabContent.addEventListener('shown.bs.tab', (event) => {
            updateSelector(event.target);
        });
    }
});



// Slider avec Swiper.js
const swiperLeft = new Swiper('.swiper-left', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    //allowTouchMove: false,
    effect: "fade",
});

const swiperCenter = new Swiper('.swiper-center', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
    effect: "fade",
});

const swiperRight = new Swiper('.swiper-right', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: false,
    allowTouchMove: false,
    effect: "fade",
});


// Synchronisation des sliders
swiperCenter.controller.control = [swiperLeft, swiperRight];

// Swiper Gallery
document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".swiper-gallery", {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        breakpoints: {
            // when window width is >= 480px
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },    
        }
    });
});
